/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit LetterRecipientPicker/view.blocks to change it.
import Content from './Content/index'
import Popover from 'DesignSystem/Popover/index'
import PopoverContentLeftClick from 'DesignSystem/Popover/PopoverContentLeftClick/index'
import PopoverTrigger from 'DesignSystem/Popover/PopoverTrigger/index'
import React from 'react'
import Trigger from './Trigger/index'



/** @type {import('Simple/types.js').View} */
export default function LetterRecipientPicker({
  children,
  viewPath = "/DesignSystem/LetterRecipientPicker",
  placement = "bottom-end",
  ignoreClickOutsideIf,
  offsetCrossAxis,
  recipientId,
  patientId,
  onSave
  
}) {
  return (<React.Fragment
>
<Popover
  viewPath={`${viewPath}/Popover`}
 placement={placement}
 ignoreClickOutsideIf={ignoreClickOutsideIf}
 offsetCrossAxis={offsetCrossAxis}
>
{childProps => (
<React.Fragment>
<PopoverTrigger
{...childProps}
  viewPath={`${viewPath}/PopoverTrigger`}
>
{childProps => (
<Trigger
{...childProps}
  viewPath={`${viewPath}/Trigger`}
 recipientId={recipientId}
/>
)}
</PopoverTrigger>
<PopoverContentLeftClick
{...childProps}
  viewPath={`${viewPath}/PopoverContentLeftClick`}
>
{childProps => (
<Content
{...childProps}
  viewPath={`${viewPath}/Content`}
 patientId={patientId}
 onSave={onSave}
/>
)}
</PopoverContentLeftClick>
</React.Fragment>
)}
</Popover>
{children}
</React.Fragment>)
}